import logo from "../../assets/images/logo.svg";
import { useState } from "react";
import { MdVisibility } from "react-icons/md";
import { MdVisibilityOff } from "react-icons/md";
import { Card, Input, Typography } from "@material-tailwind/react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { SignUpForm, SignUpValidation } from "./authValidations";
import ErrorParagraph from "../../components/common/ErrorParagraph";
import LoadingButton from "../../components/common/buttons/LoadingButton";
import {
  useOnboardingStore,
  useRegisterStore,
} from "../../store/onboarding/Onboarding";

import { useNavigate } from "react-router-dom";
import { routerPaths } from "../../services/path";
import AuthService from "../../services/authService";

function SignUp() {
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const accountType = useOnboardingStore().accountType;
  const navigation = useNavigate();
  
  const { setRegisterUser, registerUser } = useRegisterStore();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SignUpForm>({
    resolver: yupResolver(SignUpValidation),
    mode: "onChange",
  });


  const onSubmit = (data: SignUpForm) => {
    console.log(data);
    const businessData = {
      userType: 6,
      businessType: accountType === "cooperate" ? 2 : 1,
      serviceType: 2,
    };
    const newUser = { ...data, ...businessData };
    setRegisterUser(newUser);
    navigation(routerPaths.registrationDocument);

    
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="md:flex  bg-gray-50">
        <div className="invisible md:visible bg-map-background bg-no-repeat w-3/6 relative flex flex-col justify-center items-center">
          <img
            className="  absolute md:top-10 md:left-20"
            src={logo}
            alt="GIGM Logo"
          />
          <div className="text-4xl">
            <h1>It’s easier to get</h1>
            <h2 className="inline">started with{` `}</h2>
            <h2 className="inline font-extrabold text-primary">GIGM Boat</h2>
          </div>
        </div>
        <img className="ml-20 md:hidden" src={logo} alt="GIGM Logo" />
        <div className="flex items-center justify-center ">
          <div className="md:w-[60%] md:m-24 m-10">
            <h2 className=" text-2xl text-center">Create an account</h2>
            <Card placeholder={undefined} color="transparent" shadow={false}>
              <div className="mt-8 mb-2 w-80 max-w-screen-lg sm:w-96 my-auto ">
                <div className="mb-1 flex flex-col gap-6">
                  <Typography
                    placeholder={undefined}
                    variant="paragraph"
                    color="blue-gray"
                    className="-mb-3"
                  >
                    First Name
                  </Typography>
                  <Input
                    size="lg"
                    placeholder="First Name"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900 bg-white"
                    defaultValue={
                      AuthService.decryptUserData(registerUser as string)
                        ?.firstName
                    }
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    crossOrigin={undefined}
                    {...register("firstName")}
                  />
                  {errors.firstName && (
                    <ErrorParagraph message={errors.firstName.message!} />
                  )}
                  <Typography
                    placeholder={undefined}
                    variant="paragraph"
                    color="blue-gray"
                    className="-mb-3"
                  >
                    Last Name
                  </Typography>
                  <Input
                    size="lg"
                    placeholder="Last Name"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900 bg-white"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    defaultValue={
                      AuthService.decryptUserData(registerUser as string)
                        ?.lastName
                    }
                    crossOrigin={undefined}
                    {...register("lastName")}
                  />
                  {errors.lastName && (
                    <ErrorParagraph message={errors.lastName.message!} />
                  )}
                  <Typography
                    placeholder={undefined}
                    variant="paragraph"
                    color="blue-gray"
                    className="-mb-3"
                  >
                    Email
                  </Typography>
                  <Input
                    size="lg"
                    placeholder="name@mail.com"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900 bg-white"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    defaultValue={
                      AuthService.decryptUserData(registerUser as string)
                        ?.email
                    }
                    crossOrigin={undefined}
                    {...register("email", { required: true, minLength: 8 })}
                  />
                  {errors.email && (
                    <ErrorParagraph message={errors.email.message!} />
                  )}
                  <Typography
                    placeholder={undefined}
                    variant="paragraph"
                    color="blue-gray"
                    className="-mb-3"
                  >
                    Phone Number
                  </Typography>
                  <Input
                    size="lg"
                    placeholder="080*********"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900 bg-white"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    defaultValue={
                      AuthService.decryptUserData(registerUser as string)
                        ?.phoneNumber
                    }
                    crossOrigin={undefined}
                    {...register("phoneNumber", {
                      required: true,
                      minLength: 11,
                    })}
                  />
                  {errors.phoneNumber && (
                    <ErrorParagraph message={errors.phoneNumber.message!} />
                  )}
                  <Typography
                    placeholder={undefined}
                    variant="paragraph"
                    color="blue-gray"
                    className="-mb-3"
                  >
                    Address
                  </Typography>
                  <Input
                    size="lg"
                    placeholder="No ... street, city, state"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900 bg-white"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    defaultValue={
                      AuthService.decryptUserData(registerUser as string)
                        ?.address
                    }
                    crossOrigin={undefined}
                    {...register("address", {
                      required: true,
                    })}
                  />
                  {errors.address && (
                    <ErrorParagraph message={errors.address.message!} />
                  )}
                  <Typography
                    placeholder={undefined}
                    variant="paragraph"
                    color="blue-gray"
                    className="-mb-3"
                  >
                    Password
                  </Typography>
                  <Input
                    type={passwordShown ? "text" : "password"}
                    size="lg"
                    placeholder="********"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900 bg-white"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    defaultValue={
                      AuthService.decryptUserData(registerUser as string)
                        ?.password
                    }
                    icon={
                      passwordShown ? (
                        <MdVisibility onClick={() => setPasswordShown(false)} />
                      ) : (
                        <MdVisibilityOff
                          onClick={() => setPasswordShown(true)}
                        />
                      )
                    }
                    crossOrigin={undefined}
                    {...register("password")}
                  />
                  {errors.password && (
                    <ErrorParagraph message={errors.password.message!} />
                  )}
                  <Typography
                    placeholder={undefined}
                    variant="paragraph"
                    color="blue-gray"
                    className="-mb-3"
                  >
                    Confirm Password
                  </Typography>
                  <Input
                    type={confirmPasswordShown ? "text" : "password"}
                    size="lg"
                    placeholder="********"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900 bg-white"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    defaultValue={
                      AuthService.decryptUserData(registerUser as string)
                        ?.password
                    }
                    icon={
                      confirmPasswordShown ? (
                        <MdVisibility
                          onClick={() => setConfirmPasswordShown(false)}
                        />
                      ) : (
                        <MdVisibilityOff
                          onClick={() => setConfirmPasswordShown(true)}
                        />
                      )
                    }
                    crossOrigin={undefined}
                    {...register("confirmPassword")}
                  />
                  {errors.confirmPassword && (
                    <ErrorParagraph message={errors.confirmPassword.message!} />
                  )}
                </div>
                <LoadingButton isLoading={false}>Get Started</LoadingButton>
                <Typography
                  placeholder={undefined}
                  color="gray"
                  className="mt-4 text-center font-normal"
                >
                  Already have an account?{" "}
                  <a href="/signIn" className="font-medium text-gray-900">
                    Sign In
                  </a>
                </Typography>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </form>
  );
}

export default SignUp;
